module.exports = __webpack_public_path__ + "static/media/pagination-previous.0b48327c.svg";